import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import headerIconLight from '../assets/header-icon.png';
import headerIconDark from '../assets/header-icon-dark.png';

interface AppIconProps {
  className?: string; // Web-specific prop for CSS classes
  size?: number; // Custom size in pixels
}

const AppIcon: React.FC<AppIconProps> = ({ 
  className, 
  size = 32 // Default to 32px (equivalent to h-8 w-8)
}) => {
  const { theme } = useTheme();
  
  // Use different icons based on theme - same logic as RN version
  const iconSource = theme.isDark ? headerIconDark : headerIconLight;
  
  return (
    <img 
      src={iconSource}
      alt="ChordBaker Icon"
      className={className}
      style={{
        width: size,
        height: size,
        borderRadius: theme.radii.sm,
      }}
    />
  );
};

export default AppIcon;
